import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { icons } from '@finnairoyj/fcom-ui-styles';

@Component({
  selector: 'fcom-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent implements OnInit, OnChanges {
  @Input()
  category: keyof icons = 'svg-library';

  @Input()
  name: string = null;

  @Input()
  informative = false;

  iconOldLibraryMap = {
    airplane: 'aircraft-tilted',
    'alert-ball': 'alert-block',
    alert: 'alert-block',
    'alert-triangle': 'alert-block-triangle',
    baggage: 'checked-in-baggage',
    'baggage-checked': 'checked-in-baggage',
    'baggage-tag': 'baggage-with-tag',
    'bank-card': 'credit-or-debit-card',
    betting: 'legislation',
    car: 'rental-car',
    'carry-on': 'carry-on-bag',
    'chat-ball': 'chat-block',
    'check-in-baggage': 'checked-baggage',
    'checkmark-ball-checked': 'checkmark-button-selected',
    'checkmark-ball': 'checkmark-button-unselected',
    close: 'close-delete',
    'corporate-program': 'corporate-booking',
    'destination-pin': 'destination',
    'dots-horizontal': 'more',
    'e-mail': 'email',
    'external-link': 'external-tab',
    'extra-baggage': 'extra-check-in-baggage',
    'f-plus-short': 'finnair-plus',
    'f-emblem': 'finnair-emblem',
    filter: 'filter-options',
    flag: 'milestone',
    'error-ball': 'close-delete-outline',
    'finnair-blue': 'finnair-logo (custom)',
    globe: 'world-map',
    gun: 'fire-arms-prohibited',
    'hamgurger-navi': 'menu-list',
    'help-ball': 'help-block',
    'info-ball': 'info-block',
    knife: 'sharp-objects-prohibited',
    'language-settings': 'language',
    lighter: 'lighters-matches',
    liquid: 'liquid-container',
    loader: 'transfer-loader',
    location: 'gps-location',
    lock: 'lock-open',
    locked: 'lock-closed',
    'luggage-checked-in': 'baggage-check-in',
    'manage-booking': 'mmb-ticket-changes',
    medical: 'medical-assistance',
    minimize: 'minimise-chat',
    'minus-ball': 'minus-outline',
    'mobile-app': 'mobile-phone',
    'multiple-adults': 'multi-pax',
    'multiple-destinations': 'multistop',
    mute: 'volume-mute',
    'no-baggage': 'checked-in-baggage-none',
    offers: 'discounted-price',
    oneway: 'aircraft-horizontal',
    oneworld: 'oneworld-logo',
    online: 'laptop',
    passenger: 'single-pax',
    'pax-with-infant': 'adult-infant',
    'plus-account': 'finnair-emblem-block',
    'plus-ball': 'plus-outline',
    'plus-symbol': 'tier-points',
    prices: 'flight-offer',
    refresh: 'transfer-loader',
    spinner: 'transfer-loader',
    return: 'arrival',
    roundtrip: 'return-trip',
    routemap: 'flight-map',
    seat: 'seat-or-economy',
    'shop-online': 'pre-order',
    'shopping-price': 'price',
    sound: 'volume',
    'special-assistance-request': 'person-special-assist',
    'special-assistance': 'person-wheelchair',
    'sustainability-ball': 'sustainability-block',
    'ticket-changes': 'mmb-ticket-changes',
    'time-zone-ball': 'time-zone-outline',
    time: 'time-zone',
    'passenger-block': 'single-pax-block',
    'adult-with-infant': 'adult-infant',
    'destination-selector': 'flight-map',
    shopping: 'pre-order',
    'airport-terminal-block': 'airport-block',
    'airport-terminal-outline': 'airport-outline',
    backbag: 'backpack',
    check: 'checkmark',
    'user-profile-log-in': 'single-pax',
  };

  mappedName: string;

  private errorThrown = false;
  private icons = icons;

  ngOnInit(): void {
    this.mappedName = this.iconOldLibraryMap[this.name] || this.name;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.name || changes.name?.firstChange) {
      return;
    }

    this.mappedName = this.iconOldLibraryMap[changes.name.currentValue] || changes.name.currentValue;
  }

  get iconId(): string {
    return `${this.category as string}/${this.mappedName}`;
  }

  get svgPath(): string | never {
    if (this.icons[this.category] && this.icons[this.category][this.mappedName]) {
      return this.icons[this.category][this.mappedName];
    }

    this.throwSingleError(`Invalid Icon: ${String(this.category)}/${this.mappedName}`);
    return '';
  }

  // Throw an error in a timeout to stop it crashing other components but still report to sentry.
  throwSingleError(err): void {
    if (this.errorThrown) {
      return;
    }

    this.errorThrown = true;

    setTimeout(() => {
      throw new Error(err);
    }, 0);
  }
}
